import { action } from 'easy-peasy';

import { IActionSetChannelsLoading } from '../types';

const setChannelsLoading: IActionSetChannelsLoading = action((state, payload) => {
  state.channelsLoading = payload;
});

export default setChannelsLoading;
